import {
  InputElementUnion,
  ITextAreaElement,
  MaxLengthValidationSchema,
  MinLengthValidationSchema,
} from "@graffer-inc/form-schema";
import { CommonPropertiesEditor } from "../common-properties-editor";

type TextAreaEditorProps = {
  element: ITextAreaElement;
  onElementUpdate: (element: InputElementUnion) => void;
};

export const TextAreaEditor: React.FC<TextAreaEditorProps> = ({
  element,
  onElementUpdate,
}) => {
  const maxLengthSchema = element.validations.find(
    (elem) => elem.keyword === "maxLength",
  ) as MaxLengthValidationSchema | undefined;
  const minLengthSchema = element.validations.find(
    (elem) => elem.keyword === "minLength",
  ) as MinLengthValidationSchema | undefined;

  return (
    <>
      <CommonPropertiesEditor
        element={element}
        onElementUpdate={onElementUpdate}
      />
      <div className="field">
        <label className="label">プレースホルダー</label>
        <div className="control">
          <input
            className="input"
            placeholder={element.placeholder}
            value={element.placeholder}
            onChange={(e) => {
              onElementUpdate({ ...element, placeholder: e.target.value });
            }}
          />
        </div>
      </div>
      <div className="field">
        <label className="label">入力エリアの高さ</label>
        <div className="control">
          <p>{element.rows}</p>
        </div>
      </div>
      {/** InitialValueComponent */}
      <div className="field">
        <label className="label">初期値設定</label>
        {!element.initialValue && (
          <div className="control">
            <p>設定なし</p>
          </div>
        )}
        {element.initialValue && (
          <div className="control">
            <p>{element.initialValue.value.toString()}</p>
          </div>
        )}
      </div>
      {/** TextAreaValidationEditor */}
      <hr />
      {/** TODO: create common validation editor component to be used with TextInputEditor */}
      <div className="field">
        <label className="label">入力規則設定</label>
        <div className="field">
          <label className="label">最大文字数</label>
          <div className="control">
            <p>{maxLengthSchema ? maxLengthSchema.value : "設定なし"}</p>
          </div>
        </div>
        <div className="field">
          <label className="label">最小文字数</label>
          <div className="control">
            <p>{minLengthSchema ? minLengthSchema.value : "設定なし"}</p>
          </div>
        </div>
      </div>
    </>
  );
};
